module.exports = __webpack_public_path__ + "media/Simi-Ft.-Patoranking-Jericho.e035c0ee.mp3";